import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { MimecastV2 } from "@graylog/enterprise-api";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const handleSubmit = () => {
    var _a, _b;
    const fetcher = MimecastV2.checkCredentials({
      client_id: ((_a = formData == null ? void 0 : formData.clientId) == null ? void 0 : _a.value) || "",
      client_secret: ((_b = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _b.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Mimecast using provided configuration."
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Mimecast using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["mimecastName", "clientId", "clientSecret"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      className: "col-md-7",
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "mimecastName",
        type: "text",
        fieldData: formData.mimecastName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        label: "Client ID",
        help: "The Client ID for the Mimecast API application.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: "Client Secret",
        help: "The Client Secret for the Mimecast API application.",
        required: true
      }
    )
  );
};
export default StepAuthorize;
